function fetchOptions(url) {
	return fetch(url, { credentials: "same-origin" }).then((response) => {
		if (!response.ok) {
			throw new Error("Request failed");
		}

		return response.json();
	});
}

function replaceOptions(select, rows, placeholder) {
	select.innerHTML = "";
	const empty = document.createElement("option");
	empty.value = "";
	empty.textContent = placeholder;
	select.appendChild(empty);

	rows.forEach((row) => {
		const option = document.createElement("option");
		option.value = row.id;
		option.textContent = row.label;
		select.appendChild(option);
	});
}

function initForm(root) {
	const form = root.querySelector("[data-smx-garage-form]");
	if (!form) {
		return;
	}

	const brand = form.querySelector('[data-garage-step="brand"]');
	const model = form.querySelector('[data-garage-step="model"]');
	const version = form.querySelector('[data-garage-step="version"]');
	const status = form.querySelector("[data-garage-status]");
	const results = root.querySelector("[data-garage-results]");
	const garageUrl = form.dataset.garageUrl || window.location.pathname;
	const config = window.smxMyGarage || {};
	const restBase = config.restBase || "/wp-json/smx/v1/vehicle-filter/";
	let modelRequest = 0;
	let versionRequest = 0;
	let resultsRequest = 0;

	// The selects are search filters: the vehicle cards below them are rendered server side.
	function selectionUrl() {
		const url = new URL(garageUrl, window.location.origin);

		if (brand.value) {
			url.searchParams.set("cfv_brand", brand.value);
		}

		if (brand.value && model.value) {
			url.searchParams.set("cfv_model", model.value);
		}

		if (brand.value && model.value && version.value) {
			url.searchParams.set("cfv_version", version.value);
		}

		return url.toString();
	}

	function loadResults() {
		if (!results) {
			return;
		}

		const url = selectionUrl();
		const request = ++resultsRequest;

		window.history.replaceState(null, "", url);

		if (!brand.value) {
			results.innerHTML = "";
			results.removeAttribute("aria-busy");
			return;
		}

		results.setAttribute("aria-busy", "true");
		status.textContent = config.loadingLabel || "Caricamento...";

		fetch(url, { credentials: "same-origin" })
			.then((response) => {
				if (!response.ok) {
					throw new Error("Request failed");
				}

				return response.text();
			})
			.then((html) => {
				if (request !== resultsRequest) {
					return;
				}

				const doc = new DOMParser().parseFromString(html, "text/html");
				const fresh = doc.querySelector("[data-garage-results]");

				results.innerHTML = fresh ? fresh.innerHTML : "";
				results.removeAttribute("aria-busy");
				status.textContent = "";
			})
			.catch(() => {
				if (request === resultsRequest) {
					results.removeAttribute("aria-busy");
					status.textContent = config.resultsErrorLabel || "Impossibile caricare i veicoli. Riprova.";
				}
			});
	}

	function resetModel() {
		modelRequest += 1;
		replaceOptions(model, [], config.modelPlaceholder || "Seleziona il modello");
		model.disabled = true;
	}

	function resetVersion() {
		versionRequest += 1;
		replaceOptions(version, [], config.versionPlaceholder || "Seleziona la versione");
		version.disabled = true;
	}

	brand.addEventListener("change", () => {
		resetModel();
		resetVersion();
		status.textContent = "";
		loadResults();

		if (!brand.value) {
			return;
		}

		const request = ++modelRequest;
		fetchOptions(`${restBase}models?brand_id=${encodeURIComponent(brand.value)}`)
			.then((rows) => {
				if (request !== modelRequest) {
					return;
				}

				replaceOptions(model, Array.isArray(rows) ? rows : [], config.modelPlaceholder || "Seleziona il modello");
				model.disabled = false;
			})
			.catch(() => {
				if (request === modelRequest) {
					status.textContent = config.errorLabel || "Impossibile caricare le opzioni. Riprova.";
				}
			});
	});

	model.addEventListener("change", () => {
		resetVersion();
		status.textContent = "";
		loadResults();

		if (!model.value) {
			return;
		}

		const request = ++versionRequest;
		fetchOptions(`${restBase}versions?brand_id=${encodeURIComponent(brand.value)}&model_id=${encodeURIComponent(model.value)}`)
			.then((rows) => {
				if (request !== versionRequest) {
					return;
				}

				replaceOptions(version, Array.isArray(rows) ? rows : [], config.versionPlaceholder || "Seleziona la versione");
				version.disabled = false;
			})
			.catch(() => {
				if (request === versionRequest) {
					status.textContent = config.errorLabel || "Impossibile caricare le opzioni. Riprova.";
				}
			});
	});

	version.addEventListener("change", loadResults);

	form.addEventListener("submit", (event) => {
		event.preventDefault();
		loadResults();
	});
}

function init() {
	document.querySelectorAll("[data-smx-my-garage]").forEach(initForm);
}

export default { init };
